export default function WeatherOverlay({ weather }) {
  if (!weather || weather === "none") return null;
  const count = weather === "rain" ? 80 : weather === "snow" ? 60 : 0;
  const isFog = weather === "fog";

  if (isFog) {
    return <div className="absolute inset-0 pointer-events-none bg-white/5 backdrop-blur-[2px] z-10" data-testid="weather-fog-overlay" />;
  }

  return (
    <div className="absolute inset-0 pointer-events-none overflow-hidden z-10" data-testid={`weather-${weather}-overlay`}>
      {Array.from({ length: count }).map((_, i) => (
        <span
          key={i}
          className={weather === "rain" ? "weather-rain-drop" : "weather-snow-flake"}
          style={{
            left: `${Math.random() * 100}%`,
            animationDuration: `${weather === "rain" ? 0.6 + Math.random() * 0.4 : 4 + Math.random() * 4}s`,
            animationDelay: `${Math.random() * 3}s`,
          }}
        />
      ))}
      <style>{`
        .weather-rain-drop { position: absolute; top: -5%; width: 1px; height: 16px; background: rgba(180,200,255,0.5); animation: rain-fall linear infinite; }
        .weather-snow-flake { position: absolute; top: -5%; width: 4px; height: 4px; border-radius: 50%; background: rgba(255,255,255,0.8); animation: snow-fall linear infinite; }
        @keyframes rain-fall { to { transform: translateY(110vh); } }
        @keyframes snow-fall { to { transform: translateY(110vh) translateX(20px); } }
      `}</style>
    </div>
  );
}
